import { useNode } from '@craftjs/core';
import {
	SwitchControl,
	TextControl
} from 'pages/PageEditor/settingsComponents';
import { generateOnChange } from 'pages/PageEditor/settingsComponents/settingsHelpers';
import React, { useMemo } from 'react';
import { EditorInputSettings } from '../EditorInput/EditorInputSettings';

const EditorNewPasswordSettings = () => {
	const {
		confirmInputProps,
		isConfirm,
		actions: { setProp }
	} = useNode((node) => node.data.props);

	const [onIsConfirmChange, onConfirmLabelChange, onConfirmPlaceholderChange] =
		useMemo(
			() =>
				[
					'isConfirm',
					'confirmInputProps.label',
					'confirmInputProps.placeholder'
				].map((attr) => generateOnChange(setProp, attr)),
			[setProp]
		);

	return (
		<EditorInputSettings>
			<SwitchControl
				value={isConfirm}
				label={intl.tr('screenEditor.settings.input.passwordConfirm')}
				setValue={onIsConfirmChange}
				order={60}
			/>
			{isConfirm && (
				<>
					<TextControl
						value={confirmInputProps.label}
						label={intl.tr('screenEditor.settings.input.label')}
						setValue={onConfirmLabelChange}
						order={70}
						data-testid="newpassword-confirmation-label"
					/>

					<TextControl
						value={confirmInputProps.placeholder}
						label={intl.tr('screenEditor.settings.input.placeholder')}
						setValue={onConfirmPlaceholderChange}
						order={80}
						data-testid="newpassword-confirmation-placeholder"
					/>
				</>
			)}
		</EditorInputSettings>
	);
};

export { EditorNewPasswordSettings };
